/**
 * Path-param sync keeps a version-add rename hint when it matches the URL version.
 * Any other route (project list, shared, generation, or a different version) drops it.
 */
export const addedElementIdAfterPathSync = (
  addedElementId: string | undefined,
  urlVersionId: string | undefined,
): string | undefined => {
  if (urlVersionId !== undefined && addedElementId === urlVersionId) {
    return addedElementId;
  }
  return undefined;
};
